<template>

<nav class="navbar is-fixed-bottom is-primary" role="navigation" aria-label="main navigation">
   
   
   <div class=" footerNavBar">
            <div class="entete">
                {{club.name}}
    </div>
            <div class="buttonsFooter">
                <a class="boutonTournoi">
                    <div class="libelle" v-on:click="tournois"> Tournois</div>
                </a>
            </div>
             <div class="buttonsFooter" v-on:click="joueurs">
                <a class="boutonJoueur">
                    <div class="libelle" > Joueurs</div>
                </a>
            </div>
             <div class="buttonsFooter">
                <a class="boutonPartie">
                    <div class="libelle"> Ma partie</div>
                </a>
            </div>
            <div class="boutonCredit">
                <a >
                    <div class="credit">0</div>
                    <div class="libelleCredit">Crédit</div>
                </a>
            </div>
   </div>
</nav>
</template>
<style scoped>
    .footerNavBar {
        max-width: 800px;
        width: 100%;
        height: 95px;
        
    }
    .entete {
        padding-left: 20px;
        width: 100%;
        height: 10px;
        
    }
     .boutonCredit {
         display: inline-block;
         float: right;
     }
     .boutonCredit a:hover {
         opacity: 1;
     }
     .libelleCredit {
        color: white;
        font-size: 10px;
        text-align: center;
        font-weight: bolder;
     }
     .credit {
        padding-bottom: 0px;
        text-align: center;
        width: 100%;
        height: 100%;
        font-size: 30px;
        font-weight: bolder;
        color: rgb(11, 60, 124);
        
     }
    
     .buttonsFooter {
         display: inline-block;
     }
    .buttonsFooter a {
        background-repeat: no-repeat;
        background-size: 100%;
        width: 50px;
        display: inline-block;
        height: 60px;
        margin-top: 15px;
        margin-left: 10px;
        opacity: 0.80;
    }
    .libelle {
        padding-bottom: 0px;
        text-align: center;
        width: 100%;
        height: 100%;
        padding-top: 50px;
        font-size: 10px;
        font-weight: bolder;
        color: white;
    }    
    
    
</style>
<script>
export default {
    props: ["club"],
    methods: {
        loader() {this.$loading.show({
            loader: 'spinner',
            color: '#e8b30f',
            backgroundColor: '#000',
            opacity: 0.5,
        })
        },
        joueurs() {
            this.$emit("joueurs");
           // this.$router.replace("./joueurs/"+this.club.id);
        },
        tournois() {
            this.$emit("tournois");
        }
    }
}
</script>